{
  "markread": "markeer gelezen",
  "newest": "nieuwste",
  "unread": "ongelezen",
  "starred": "met ster",
  "tags": "Tags",
  "alltags": "alle tags",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 hour},other {# uren}} geleden",
  "minutes": "{0,plural,one {1 minute},other {# minuten}} geleden",
  "seconds": "{0,plural,one {1 second},other {# seconden}} geleden",
  "days": "{0,plural,zero {vandaag},one {gisteren},other {# dagen geleden}}",
  "star": "ster",
  "unstar": "ster verwijderen",
  "mark": "gelezen",
  "unmark": "ongelezen",
  "load_img": "afbeeldingen tonen",
  "open_window": "open",
  "searchbutton": "zoeken",
  "sources": "Bron",
  "source_add": "bron toevoegen",
  "source_opml": "of importeer opml bestand of google reader",
  "source_export": "exporteer bronnen",
  "source_edit": "wijzig",
  "source_delete": "verwijder",
  "source_warn": "bron echt verwijderen?",
  "source_new": "nieuwe bron",
  "source_title": "Titel",
  "source_tags": "Tags",
  "source_comma": "komma gescheiden",
  "source_select": "selecteer een bron",
  "source_type": "Soort",
  "source_save": "opslaan",
  "source_cancel": "annuleren",
  "source_saved": "opgeslagen",
  "source_last_post": "Meest recente artikel is gevonden",
  "no_entries": "geen items gevonden",
  "more": "meer",
  "login": "inloggen",
  "login_username": "gebruikersnaam",
  "login_password": "wachtwoord",
  "no_title": "geen titel"
}
